import { withStyles } from '@material-ui/core';
// This tooltp component is especially created to support gantt chart used for DP Report.

const styles = {
  tooltipContainer: {
    position: 'relative',
    display: 'inline-block',
    '&:hover $tooltipText': {
      visibility: 'visible'
    }
  },
  tooltipText: {
    visibility: 'hidden',
    width: 'max-content',
    backgroundColor: '#EFEFEE',
    color: '#3E3E3E',
    textAlign: 'center',
    boxShadow: `0px 0px 2px 0px #7D7D7E`,
    borderRadius: 2,
    padding: 5,
    fontSize: 12,
    opacity: 1,
    wordBreak: 'break-word',
    position: 'absolute',
    zIndex: 1,
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-10%)',
  }
};
const CustomTooltip = withStyles(styles)(({ classes, children, title }) => {
  return (
    <div className={classes.tooltipContainer}>
      {children}
      <span className={classes.tooltipText}>{title}</span>
    </div>
  );
});

export default withStyles(styles)(CustomTooltip);
